import { create } from 'zustand';
import { 
  get_plans, 
  post_plan, 
  update_plan, 
  delete_plan 
} from '../utils/apis/plans';

export const usePlanStore = create((set, get) => ({
  plans: [],
  loading: false,
  error: null,

  getPlanList: async () => {
    set({ loading: true });
    try {
      const result = await get_plans();
      set({ plans: result || [], loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  postNewPlan: async (data) => {
    set({ loading: true });
    try {
      const res = await post_plan(data);
      if (res && res.inserted_id) {
        await get().getPlanList();
      }
      set({ loading: false });
      return res;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  updatePlan: async (data) => {
    set({ loading: true });
    try {
      const res = await update_plan(data);
      await get().getPlanList();
      set({ loading: false });
      return res;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  deletePlan: async (data) => {
    set({ loading: true });
    try {
      await delete_plan(data);
      await get().getPlanList();
      set({ loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));
